import { MainMapPlaceService } from '@bvt-features/mainmap/place/service';

const { createAsyncThunk } = require('@reduxjs/toolkit');

const mainMapPlaceService = new MainMapPlaceService();

const asyncActionCheckMarkerIsValid = createAsyncThunk(
  'LI/pertamina/droppable-marker/check-area',
  async ({ latitude, longitude, id_source }, { rejectWithValue }) => {
    try {
      const placeData = await mainMapPlaceService.get_coordinates({
        meta: {
          filter: {
            id_source: id_source,
            longitude: longitude,
            latitude: latitude,
          },
        },
      });
      return placeData;
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

export { asyncActionCheckMarkerIsValid };
